import router from '@/router';
import mutations from '../ads/ads.mutationlist';

export default {
  fetchAds: ({ commit, state }) => new Promise(
    (resolve, reject) => router.app.$http.get('ads', {
      params: {
        file: true,
        currency: true,
        favoring_logged_in_user: true,
        filters: state.filters,
      },
    })
      .then((response) => {
        if (response && response.data) {
          commit(mutations.SET_ADS, response.data.data);
        }
        resolve(response.data);
      }, (error) => {
        reject(error);
      }),
  ),
};



// WEBPACK FOOTER //
// ./src/store/ads/ads.actions.js